// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// components.
import { RulePanelRow } from "./RulePanelRow";

interface ContenderPanelProps {
  experiments: RawRuleItem[];
  canPromote: boolean;
  onPromote: () => void;
  onEdit: (rule: RawRuleItem) => void;
  onToggle: (rule: RawRuleItem) => void;
}

export const ContenderPanel = ({
  experiments,
  canPromote,
  onPromote,
  onEdit,
  onToggle,
}: ContenderPanelProps) => {
  const activeCount = experiments.filter((r) => r.is_active === "active").length;
  const sorted = [...experiments].sort((a, b) => a.rule.priority - b.rule.priority);

  return (
    <div className="dashboard-panel dashboard-panel--experiments">
      <div className="panel-header panel-header--contender">
        <div className="panel-title-group">
          <span className="boxing-label label--contender">🥊 Contender</span>
          <p className="panel-title">Experimentos</p>
          <span className="panel-count count--experiments">
            {activeCount} activo{activeCount !== 1 ? "s" : ""}
          </span>
        </div>
        <button
          className="icon-btn icon-btn--promote"
          onClick={onPromote}
          disabled={!canPromote}
          title={canPromote ? "Promover contender a ganador" : "No hay experimentos activos"}
        >
          🏆 Promover
        </button>
      </div>

      <div className="panel-body">
        {sorted.length === 0 ? (
          <p className="panel-empty">
            No hay experimentos activos.
            <br />
            <span style={{ fontSize: 11, marginTop: 4, display: "block" }}>
              Crea una regla de tipo Contender desde el botón "＋ Nueva regla".
            </span>
          </p>
        ) : (
          sorted.map((rule) => (
            <RulePanelRow
              key={rule.rule_id}
              rule={rule}
              variant="contender"
              onEdit={onEdit}
              onToggle={onToggle}
            />
          ))
        )}
      </div>
    </div>
  );
};
